<script setup lang="ts">
import LayoutSwitch from '@/components/layouts/LayoutSwitch.vue';
</script>

<template>
  <LayoutSwitch>
    <RouterView />
  </LayoutSwitch>
</template>
